import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'shared/components/icon';
import List from 'shared/components/list';
import SchoolRadioButton from './school-radio-button';

class SchoolList extends React.Component {
  static propTypes = {
    schools: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        city: PropTypes.string,
        state: PropTypes.string,
        country: PropTypes.string,
        campuses: PropTypes.arrayOf(PropTypes.string),
      })
    ),
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onSelect: PropTypes.func.isRequired,
    labelTemplate: PropTypes.string,
  };

  static defaultProps = {
    labelTemplate: '${name}<br />${city}, ${state}',
  };

  render() {
    const {schools, value, onSelect, labelTemplate} = this.props;

    if (schools.length === 0) {
      return <Icon iconType="spinner" className="rm-spin" style={{fontSize: 30}} />;
    }

    return (
      <div className="school-list">
        <List>
          <fieldset
            className="radio-buttons"
            role="radiogroup"
            aria-label="Where do you go to school?"
          >
            <legend style={{display: 'none'}}>Where do you go to school?</legend>
            {schools.map((school, index) => (
              <SchoolRadioButton
                labelTemplate={labelTemplate}
                school={school}
                key={`${school.name}-${index}`}
                onSelect={onSelect}
                selected={school.id === value}
                cy={`schoolOption.${index}`}
              />
            ))}
          </fieldset>
        </List>
      </div>
    );
  }
}

export default SchoolList;
